import type { LegacySyncRunResult } from "../types";

/** 格式化同步结果模式。 */
export function formatLegacySyncMode(mode: LegacySyncRunResult["mode"]) {
  return mode === "dry_run" ? "预览" : "执行同步";
}

/** 格式化同步结果状态。 */
export function formatLegacySyncStatus(status: LegacySyncRunResult["status"]) {
  if (status === "planned") {
    return "已生成计划";
  }
  if (status === "started") {
    return "执行中";
  }
  if (status === "completed") {
    return "已完成";
  }
  if (status === "paused") return "已安全暂停";
  if (status === "partial_failed") return "本批完成，部分待处理";
  if (status === "blocked") {
    return "已阻止";
  }
  if (status === "failed") {
    return "失败";
  }
  if (status === "not_enabled") {
    return "未开放";
  }
  return "未实现";
}

/** 只用业务组证据判断展示结论，不把明细计划行数当作成功数。 */
export function describeLegacySyncResult(result: LegacySyncRunResult) {
  const business = result.businessResult;
  if (!business) return formatLegacySyncStatus(result.status);
  if (result.mode === "dry_run") return "预览完成，尚未执行";
  if (result.status === "started") return "正在同步";
  if (result.status === "paused") return "已暂停，保留已同步结果";
  if (result.status === "failed") return "同步已停止，请核对未同步原因";
  if (business.pending > 0) return business.synced > 0 ? "部分同步成功" : "尚有对象未同步";
  return result.status === "completed" ? "本次范围已全部处理完成" : formatLegacySyncStatus(result.status);
}

/** 合同按定制号聚合，供应商附属类型不能冒充供应商主体数。 */
export function legacySyncBusinessUnit(target: string) {
  if (target === "order_handover") return "个定制单";
  if (target === "itinerary") return "个行程";
  if (target === "resource_point_spu") return "个考察点";
  if (["supplier_ground", "supplier_hotel", "supplier_bus", "supplier_guide"].includes(target)) return "家供应商";
  return "个对象";
}
